// angular
import { Component, Input, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { AppService } from '../../../app.service';
import { MeRegisterService } from '../me-register.service';

@Component({
    selector: 'me-register-voucher-card',
    templateUrl: './voucher-card.component.html',
    styleUrls: ['./voucher-card.component.scss']
})

export class MeRegisterVoucherCardComponent implements OnInit {
    data = null;
    url = 'register/vouchercard';
    folder = 'core';
    form: FormGroup;
    errorInput = false;

    constructor(
        public appService: AppService,
        public fb: FormBuilder,
        public translate: TranslateService,
        public meRegisterService : MeRegisterService
    ) {

    }

    ngOnInit() {
        this.form = this.fb.group({
            voucher: ['', []],
        });

        this.getContent();
        this.translate.onLangChange.subscribe(value => {
            this.getContent();
        });
    }

    getContent() {
        this.appService.getStoryBlokDataForClinic(this.url).subscribe(res => {
            this.data = res['story']['content'];
        });
    }

    checkVoucher(value) {

        let voucher = value.voucher;
        if (voucher == '') {
            this.meRegisterService.step = 4;
            return;
        }
        
        this.errorInput = false;
        this.meRegisterService.checkVoucher(voucher).subscribe(res => {
            this.appService.setMeClinicId(res['clinic_id']);
            this.appService.setMeClinicFolderViaClinicId(res['clinic_name']);
            this.meRegisterService.step = 4;
        },
        error => {
            this.errorInput = true;
        });
    }
}
